import { IconArrowRightLight, IconInfoLight } from '@croquiscom-pvt/zds';

import * as S from '../../styles/zinzinStyle';

interface ZigzinDelayShipmentBannerProps {
  url: string;
  handleClick: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}

export const ZigzinDelayShipmentBanner: React.FC<React.PropsWithChildren<ZigzinDelayShipmentBannerProps>> = ({ url, handleClick }) => {
  return (
    <S.Wrapper>
      <S.Link target={'_blank'} href={url} onClick={handleClick} rel='noopener noreferer'>
        <S.InfoIcon>
          <IconInfoLight v3Color='gray700' />
        </S.InfoIcon>
        추석 연휴 배송 휴무 안내
        <S.ArrowIcon>
          <IconArrowRightLight v3Color='gray300' />
        </S.ArrowIcon>
      </S.Link>
    </S.Wrapper>
  );
};
